<template>
    <div class="flashes text-justify">
        <transition-group name="list-flashes" tag="div">
            <div v-bind:key="flash.id" v-for="flash in getCurrentStateFlashes" :class="getClassName(flash.type)" role="alert">
                {{flash.message}}
            </div>
        </transition-group>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";

    export default {
        name: "Basic",
        computed: {
            ...mapGetters("flash", ["getCurrentStateFlashes"])
        },
        methods: {
            getClassName: function(type) {
                const base = "alert alert-";
                if (!type || type === "error" || type === "danger") {
                    return base + "danger";
                } else if (type === "warning" || type === "warn") {
                    return base + "warning";
                } else if (type === "info") {
                    return base + "info";
                }
                return base + "success";
            }
        }
    }
</script>

<style scoped>
    .list-flashes-enter-active, .list-flashes-leave-active {
        transition: all 1s;
    }
    .list-flashes-enter {
        opacity: 0;
        transform: translateY(30px) scale(1.3);
    }
    .list-flashes-leave-to {
        opacity: 0;
        transform: translateY(-30px) scale(0.7);
    }
</style>